import type { PropertyResponse } from '@/shared/api';

/**
 * Wie ein Apartment in einer fremden Liste heißt.
 *
 * Der Grund für diese eine Stelle: Buchungsliste, Reinigung und Kalender bauten ihre
 * Namensauflösung je aus einer Apartmentliste, die per Default nur `Active` lädt. Eine Buchung im
 * **archivierten** Apartment fand dort nichts und fiel auf `propertyId.slice(0, 8)` zurück — der
 * Betreiber las `3f9a21c7…`. G3 hat entschieden, solche Zeilen anzunehmen und zu zeigen; dann muss
 * die Liste sie auch benennen können.
 *
 * Deshalb heißt der Vertrag hier: die Quelle lädt **alle** Lifecycle-Zustände. Der Fallback bleibt
 * als letzte Reißleine stehen, ist aber kein erwarteter Weg mehr.
 */
export interface PropertyLabel {
  name: string;
  archived: boolean;
}

export function buildPropertyLabels(
  properties: readonly PropertyResponse[],
): ReadonlyMap<string, PropertyLabel> {
  const labels = new Map<string, PropertyLabel>();
  for (const property of properties) {
    labels.set(property.id, {
      name: property.adminDisplayName ?? property.name,
      archived: property.status === 'Archived',
    });
  }
  return labels;
}

/** Kurzform für Stellen, die nur den Namen brauchen. */
export function labelFor(
  labels: ReadonlyMap<string, PropertyLabel>,
  propertyId: string,
): PropertyLabel {
  return labels.get(propertyId) ?? { name: `${propertyId.slice(0, 8)}…`, archived: false };
}
